var modCheckoutDate = function(){
    var scope = ".js-mod-checkout-date";
    var scopeCart = ".js-mod-cart-detail";

    function updateCartContents(){
        var $mod = $(scopeCart);
        gvf.endpoint(
            "web\\shopCartController::getCartContents",
            [],
            function(response){
                if(response.status=="ok"){
                    var $cart = $(response.html);
                    $mod.replaceWith($cart);
                    $mod = $cart;
                    ui.init($mod);
                }
            }
        );
    }

    function getCartDetail() {
        var $mod = $(scope);
        gvf.endpoint(
            "web\\shopProcessController::showViewCartDetail",
            null,
            function(response){
                if(response){
                    var $cartModal = $mod.find(scope+"__cart-detail");
                    var $html = $(response.html);
                    $html.removeClass("web-mod-cart-detail");
                    $cartModal.append($html);
                    ui.init($cartModal);

                }else{
                    utils.alertEndpointResponse(response);
                }
            }
        );
    }

    function getSlotsDetail(selectedDate = null) {
        var $mod = $(scope);
        return new Promise(function(resolve,reject){
            gvf.endpoint(
                "web\\shopProcessController::getSlotsDetail",
                [selectedDate],
                function(response){
                    if(response){
                        var $slotContent = $mod.find(scope+"__create-div-slot");
                        var $html = $(response.html);
                        $slotContent.html($html);
                        ui.init($slotContent);
                        resolve();
                    }else{
                        utils.alertEndpointResponse(response);
                        reject(response);
                    }
                }
            );
        })
    }

    ui.ready(
        scope,
        function($mod){
            var $confirmButton = $mod.find(scope+"__confirm-step");
            var selectedDate = $mod.data("selected-date");
            var calendar = null;
            var validDatesAttr = $mod.data("valid-dates");
            var validDates = {};
            var slotId = $mod.find(scope+"__select-slot").data("id");
            var $showCartButton = $mod.find(scope+"__show-cart-detail");
            var lang = null;

            for(var i in validDatesAttr){
                validDates[validDatesAttr[i]] = true;
            }

            $showCartButton.click(
                function(ev){
                    ev.preventDefault();
                    var $cartModalBody = $mod.find(scope+"__create-address-modal-body");
                    gvf.endpoint(
                        "web\\shopProcessController::showViewCartDetail",
                        null,
                        function(response){
                            if(response){
                                var $cartModal = $mod.find(scope+"__create-cart-modal").clone();
                                ui.init($cartModal);
                                var $cartModalBody = $cartModal.find(scope+"__create-cart-modal-body");
                                $cartModalBody.empty();
                                $cartModal.find("#createCartModalTitle").text("Resumen del pedido");
                                $cartModalBody.append(response.html);
                                ui.init($cartModalBody);
                                $cartModal.modal('show');

                            }else{
                                utils.alertEndpointResponse(response);
                            }
                        }
                    );
                }
            );

            if($('body').data('lang') == 'be'){
                lang = 'fr';

            }else if ($('body').data('lang') == 'fr'){
                lang = 'fr';

            }else if ($('body').data('lang') == 'it'){
                lang = 'it';

            }else if ($('body').data('lang') == 'pt'){
                lang = 'pt';

            }else{
                lang = 'es';
            }

            calendar = new FullCalendar.Calendar(
                $mod.find(scope+"__calendar").get(0),
                {
                    initialView: 'dayGridMonth',
                    locale: lang,
                    longPressDelay:1,
                    select: function(info) {
                        if(validDates[info.startStr]){
                            selectedDate = info.startStr;
                            //calendar.viewRender(view,selectedDate);
                            gvf.endpoint(
                                "web\\shopProcessController::getValideSlot",
                                [selectedDate],
                                function(response){
                                    if(response){
                                        getSlotsDetail(selectedDate).then(
                                            function(item){
                                                $mod.find(scope+"__select-slot").show();
                                                $mod.find(scope+"__select-slot").removeClass("is-selected");
                                                gvf.endpoint(
                                                    "web\\dateController::getShopProcessDataCalendarSlotId",
                                                    [response],
                                                    function(resp){
                                                        if(resp){
                                                            $mod.find(scope+"__select-slot[data-id="+resp+"]").addClass("is-selected");
                                                            slot = resp;
                                                        }
                                                        // else{
                                                        //     $mod.find(scope+"__select-slot[data-loop-index]:not(.is-disabled)").eq(0).addClass("is-selected");
                                                        //     slot = $mod.find(scope+"__select-slot[data-loop-index]:not(.is-disabled)").eq(0).data("id");
                                                        // }
                                                        gvf.endpoint(
                                                            "web\\dateController::updateshopProcessWithSlotCost",
                                                            [slot],
                                                            function(response){
                                                                if(response.status == 'ok'){
                                                                    updateCartContents();
                                                                    getCartDetail();
                                                                }
                                                            }
                                                        )
                                                    }
                                                )
                                            }
                                        );

                                    }else{
                                        $mod.find(scope+"__select-slot").hide();
                                        $mod.find(scope+"__select-slot").removeClass("is-selected");
                                        gvf.endpoint(
                                            "web\\dateController::updateshopProcessWithSlotCost",
                                            [null],
                                            function(response){
                                                if(response.status == 'ok'){
                                                    updateCartContents();
                                                    getCartDetail();
                                                    getSlotsDetail(selectedDate);
                                                }
                                            }
                                        )
                                    }
                                }
                            )
                        }else{
                            calendar.unselect();
                        }
                    },
                    unselectAuto: false,
                    dayCellClassNames: function(arg) {
                        var month = arg.date.getMonth()+1;
                        var day = arg.date.getDate();
                        var date = arg.date.getFullYear().toString()+"-"+(month<10?"0":"")+month.toString()+"-"+(day<10?"0":"")+day.toString();
                        arg.isSelected = (selectedDate==date);
                        if(validDates[date]){
                            return "is-enabled";
                        }else{
                            return "is-disabled";
                        }
                    },
                    contentHeight:400,
                    headerToolbar:{
                        start: 'title',
                        center: '',
                        end: 'prev,next'
                    },
                    selectable:true,
                    firstDay:1,
                    navLinks: false

                }
            );
            calendar.render();
            $mod.find(".fc-button-group").click(
                function(){
                    if(selectedDate){
                        calendar.select(selectedDate);
                    }
                }
            );

            $mod.find(scope+"__create-div-slot").on(
                "click",
                scope+"__select-slot",
                function(ev){
                    ev.preventDefault();
                    disabledSlot = $(this).data("disabled_slot");
                    slotId = $(this).data("id");
                    if(!disabledSlot){
                        $mod.find(scope+"__select-slot").removeClass("is-selected");
                        $(ev.currentTarget).addClass("is-selected");
                        gvf.endpoint(
                            "web\\dateController::updateshopProcessWithSlotCost",
                            [slotId],
                            function(response){
                                if(response.status == 'ok'){
                                    updateCartContents();
                                    getCartDetail();
                                }
                            }
                        )
                    }
                }
            );

            $confirmButton.click(
                function(ev){
                    ev.preventDefault();
                    $confirmButton.prop("disable",true);
                    gvf.endpoint(
                        "web\\shopProcessController::confirmStep",
                        [$mod.data("step"),{"delivery_date":selectedDate,"calendar_slot_id":slotId, "comments":$mod.find("[name=comments]").val()}],
                        function(response){
                            $confirmButton.prop("disable",false);
                            if(response.status=="ok"){
                                window.location = response.url;
                            }else{
                                if(response.url){
                                    window.location = response.url;
                                }else{
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        }
                    );
                }
            );

            if(selectedDate){
                setTimeout(
                    function(){
                        calendar.select(selectedDate);
                    },
                    100
                );
            }

            $mod.find(scope+"__cancel-edit-subscription").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\subscriptionsController::cancelSubscriptionEditing",
                        [],
                        function(response){
                            if(response.url){
                                window.location = response.url;
                            }else{
                                window.location.reload();
                            }
                        }
                    )
                }
            );
        }
    );
}();
